(function () {
  'use strict';

  // 数量加减
  document.querySelectorAll('.sc-qty').forEach(function (box) {
    var input = box.querySelector('input');
    if (!input) return;
    box.querySelectorAll('button[data-step]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var cur = parseInt(input.value, 10) || 1;
        input.value = btn.getAttribute('data-step') === 'down' ? Math.max(1, cur - 1) : cur + 1;
      });
    });
  });

  // 变体联动：把 option 下拉的选择映射回 variant id
  var form = document.getElementById('sc-product-form');
  if (!form) return;
  var idSelect = form.querySelector('select[name="id"]');
  var optSelects = Array.prototype.slice.call(form.querySelectorAll('.sc-variant-select'));
  if (!idSelect || !optSelects.length) return;

  var variants = Array.prototype.map.call(idSelect.options, function (o) {
    return { id: o.value, title: (o.textContent || '').trim() };
  });

  function sync() {
    var picked = optSelects.map(function (s) { return (s.value || '').trim(); });
    var match = variants.filter(function (v) {
      return picked.every(function (val) { return v.title.indexOf(val) > -1; });
    })[0];
    if (match) idSelect.value = match.id;
  }

  optSelects.forEach(function (s) { s.addEventListener('change', sync); });
  sync();
})();
